import electronBridge from '../utils/electronBridge';
import ContextualVideoLink from '../components/ContextualVideoLink';

export default function Chat() {
    let chatURL = process.env.PUBLIC_URL + "/llm-chat.html";

    return (
        <div className="w-full h-full flex flex-col">
            <div className="flex justify-end px-4 py-2">
                <ContextualVideoLink tutorialCategoryId={7} />
            </div>
            <iframe
                src={chatURL}
                className="w-full flex-1"
                data-supademo-ignore="true"
                data-no-track="true"
                sandbox="allow-scripts allow-same-origin allow-forms"
            />
        </div>
    );
}